(function () {
  let badgeData = [];

  function getVariantData() {
    const jsonScript = document.querySelector('#availability-variant-data');
    if (!jsonScript) return [];
    try {
      return JSON.parse(jsonScript.textContent);
    } catch (e) {
      return [];
    }
  }

  function buildVariantById(variants) {
    const variantById = new Map();

    variants.forEach(function (v) {
      variantById.set(String(v.id), v);
    });

    return variantById;
  }

  function updateBadge(variant) {
    if (!badgeData.length) return;

    badgeData.forEach(function (entry) {
      const badge = entry.badge;
      const label = entry.label;

      if (!variant || !variant.available) {
        badge.classList.remove('show-stock-badge');
        return;
      }

      badge.classList.add('show-stock-badge');

      if (!label) return;

      const managedByShopify = variant.inventory_management === 'shopify';
      const qty = variant.inventory_quantity;
      const lowStock = managedByShopify && qty > 0 && qty < 10;

      if (lowStock) {
        badge.classList.add('inventory--low');
        badge.classList.remove('out-of-stock');
        label.textContent = 'Availability : ' + qty + ' In Stock';
      } else if (managedByShopify && qty <= 0) {
        badge.classList.add('out-of-stock');
        badge.classList.remove('inventory--low');
        label.textContent = 'Availability : Out Of Stock';
      } else {
        badge.classList.remove('inventory--low');
        badge.classList.remove('out-of-stock');
        label.textContent = 'Availability : In Stock';
      }
    });
  }

  function initInventoryBadge() {
    const variants = getVariantData();
    if (!variants.length) return;

    const variantById = buildVariantById(variants);

    badgeData = Array.from(document.querySelectorAll('.availability-badge')).map(function (badge) {
      return {
        badge: badge,
        label: badge.querySelector('.availability-badge__label'),
      };
    });

    if (!badgeData.length) return;

    const hiddenVariantInput = document.querySelector('input.product-variant-id');
    const variantSelects = document.querySelector('variant-selects');

    function updateFromVariantId(id) {
      updateBadge(id ? variantById.get(String(id)) || null : null);
    }

    if (variantSelects && variantSelects.currentVariant && variantSelects.currentVariant.id) {
      updateFromVariantId(variantSelects.currentVariant.id);
    } else if (hiddenVariantInput && hiddenVariantInput.value) {
      updateFromVariantId(hiddenVariantInput.value);
    }

    if (variantSelects) {
      variantSelects.addEventListener('change', function () {
        if (!variantSelects.currentVariant) {
          updateBadge(null);
          return;
        }

        updateFromVariantId(variantSelects.currentVariant.id);
      });
    }

    if (hiddenVariantInput) {
      hiddenVariantInput.addEventListener('change', function (e) {
        updateFromVariantId(e.target.value);
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        const variant = event.data && event.data.variant;

        if (!variant) {
          updateBadge(null);
          return;
        }

        updateFromVariantId(variant.id);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInventoryBadge);
  } else {
    initInventoryBadge();
  }
})();
